import React from "react";

import Esg from "./esg";
import List from "./Board/list";
import Gallery from "./Board/gallery";
import Upload from "./Board/upload";
import Info from "./Board/info";
import ListSafe from "./Board_safety/list";
import InfoSafe from "./Board_safety/info";
import UploadSafe from "./Board_safety/upload";

let routes = [];
routes = routes.concat({ path: "/esg", exact: true, name: "Esg", component: <Esg /> });
routes = routes.concat({ path: "/board/list", exact: true, name: "List", component: <List /> });

// 게시판
routes = routes.concat({ path: "/board/gallery", exact: true, name: "Gallery", component: <Gallery /> });
routes = routes.concat({ path: "/board/upload", exact: true, name: "Upload", component: <Upload /> });
routes = routes.concat({ path: "/board/info/:board/:id", exact: true, name: "Info", component: <Info /> });

// 안전보건 게시판
routes = routes.concat({ path: "/board_safety/list", exact: true, name: "List", component: <ListSafe /> });
routes = routes.concat({ path: "/board_safety/upload", exact: true, name: "Upload", component: <UploadSafe /> });
routes = routes.concat({ path: "/board_safety/info/:board/:id", exact: true, name: "Info", component: <InfoSafe /> });

export default routes;
